module.exports = __webpack_public_path__ + "491ea9787f93fb36f0f7d061e038f782.svg";